import { all, fork, call, takeLatest, put, select } from 'redux-saga/effects';
import api from '@api/api';
import { SHOW_MODAL } from '@store/actions/commonAction';
import * as actions from '@store/actions/roleMenuAction';
import { push } from 'connected-react-router';
import { fileDown } from '@common/utils/excelDown';

let modalMsg = '';

//어플리케이션 롤의 메뉴 조회
function* getRoleMenuList({ payload }) {

    const { status, data } = yield call(api.getRoleMenuList, {
        payload: {            
            roleId: payload.roleId,
            aplctnTpCd: payload.aplctnTpCd,
            aplctnDvcTyCd: payload.aplctnDvcTyCd
        },
    });

    if (status === 200) {

        yield put({
             type: 'GET_ROLE_MENU_LIST_SUCCESS',
             payload: data,
        });

    }
}

//어플리케이션 롤 메뉴 저장
function* saveApplicationRoleMenu({payload}) {
    
    const { status, data } = yield call(api.saveApplicationRoleMenu, {
        payload: payload.List
    });

    if (status === 200) {

        modalMsg = '수정되었습니다.';

        yield put({
            type: SHOW_MODAL,
            payload: {
              visible: true,
              type: 'info',
              msg: modalMsg,
            },
        });

        // const {searchRoleMenuInfo: {roleId} } = yield select(state => state.roleMenuReducer);
        
        // yield put({
        //     type: actions.GET_ROLE_MENU_LIST,
        //     payload: {                
        //         roleId: roleId
        //     }
        // });

        if (payload.callback)
        payload.callback(status, data);   

    }
}


//어플리케이션 권한 전체 조회
function* getApplicationRolesWithNoPaging({ payload }) {

    const { status, data } = yield call(api.getApplicationRolesWithNoPaging, {
        payload: {            
            useYn: payload.useYn
        },
    });

    if (status === 200) {

        yield put({
             type: 'GET_APPLICATION_ROLES_WITHNOPAGING_SUCCESS',
             payload: data,
        });

    }
}

//어플리케이션 권한 조회(USEYN:Y)
function* getApplicationRolesUseYn({ payload }) {

    const { status, data } = yield call(api.getApplicationRoles, {
        payload: {
            aplctnTpCd: payload.aplctnTpCd,
            useYn: payload.useYn,             
            targetRow: payload.targetRow
        },
    });
    
    if (status === 200) {

        yield put({
             type: 'GET_APPLICATION_ROLES_USE_YN_SUCCESS',
             payload: data,
        });      
        
        // yield put({
        //     type: actions.GET_ROLE_MENU_LIST,
        //     payload: {            
        //         roleId: data.RSLT_DATA.pagingResult.list[0].roleId,
        //         aplctnTpCd: payload.aplctnTpCd,
        //         aplctnDvcTyCd: payload.aplctnDvcTyCd
        //     }
        // });

    }

    if (payload.callback)
    payload.callback(status, payload);   
}

//어플리케이션 권한 상세 조회
function* getApplicationRoleDetail({ payload }) {

    const { status, data } = yield call(api.getApplicationRolesWithNoPaging, {
        payload: {            
            aplctnTpCd: payload.aplctnTpCd,
            roleId: payload.roleId
        },
    });

    if (status === 200) {

        yield put({
             type: 'GET_APPLICATION_ROLE_DETAIL_SUCCESS',             
             payload: data
        });               

    }
}


//권한별 메뉴 엑셀다운로드
function* roleMenuExcelDownload({ payload }) {

    const { status, data } = yield call(api.roleMenuExcelDownload, {
        payload: {
            aplctnTpCd: payload.aplctnTpCd,
            aplctnDvcTyCd: payload.aplctnDvcTyCd,
            roleId : payload.roleId
        },
    });

    if (status === 200) {
        fileDown(data, payload.excelFileName);
    }

}


// watcher
function* watchMenu() {
    yield takeLatest(actions.GET_ROLE_MENU_LIST, getRoleMenuList);    
    yield takeLatest(actions.SAVE_APPLICATION_ROLE_MENU, saveApplicationRoleMenu);
    yield takeLatest(actions.GET_APPLICATION_ROLES_WITHNOPAGING, getApplicationRolesWithNoPaging);
    yield takeLatest(actions.GET_APPLICATION_ROLES_USE_YN, getApplicationRolesUseYn);
    yield takeLatest(actions.GET_APPLICATION_ROLE_DETAIL, getApplicationRoleDetail);
    yield takeLatest(actions.ROLE_MENU_EXCEL_DOWNLOAD, roleMenuExcelDownload);

}


export default function* roleMenuSaga() {
    yield all([fork(watchMenu)]);
}  